module.exports = __webpack_public_path__ + "images/mobile/stars/upload-c89295501dbd8422778c8664c81404ea.png";